import { render, staticRenderFns } from "./rejectedRegistrations.vue?vue&type=template&id=40aaae04"
import script from "./rejectedRegistrations.vue?vue&type=script&lang=js"
export * from "./rejectedRegistrations.vue?vue&type=script&lang=js"
import style0 from "./rejectedRegistrations.vue?vue&type=style&index=0&id=40aaae04&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports